import {
  useSessionStore,
} from "~/stores/session";

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) {
    return;
  }

  // Skip auth check for public routes
  const publicRoutes = ["/", "/login", "/register"];
  if (publicRoutes.includes(to.path)) {
    return;
  }

  const sessionStore = useSessionStore();

  // Wait for session to be ready
  if (!sessionStore.ready) {
    await sessionStore.initialize();
  }

  // If not authenticated, redirect to login
  if (!sessionStore.isAuthenticated) {
    return navigateTo("/login");
  }

  await sessionStore.ensureAgreementStatus();
  if (sessionStore.requiresAgreement && to.path !== "/agreement") {
    return navigateTo("/agreement");
  }

  await sessionStore.fetchRegistrationPaymentStatus();
  if (sessionStore.user?.status === "pending") {
    const allowed = ["/home", "/profile", "/my-credits-usage", "/agreement"];
    if (!allowed.includes(to.path)) {
      return navigateTo("/home");
    }
  }
});
